import type { CollectState } from '@goodtime/shared';
import { api } from './client';

/** The player's relics on a slot (reel collectibles), or null when they
 *  aren't on for them there (the server answers 204) or it can't be reached. */
export async function fetchCollect(sessionId: string, themeId: string): Promise<CollectState | null> {
  try {
    const state = await api<CollectState | undefined>(
      `/sessions/${encodeURIComponent(sessionId)}/collect?themeId=${encodeURIComponent(themeId)}`,
    );
    return state ?? null;
  } catch {
    return null;
  }
}
